import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"background":"#ECECEC"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_Card = _resolveComponent("Card")!
  const _component_loader = _resolveComponent("loader")!
  const _component_DownloadForm = _resolveComponent("DownloadForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { title: "Invoices" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, { style: {"text-align":"left"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "Invoices"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  loading: _ctx.loading == 'loading',
                  columns: _ctx.fields,
                  data: _ctx.items.data,
                  pagination: _ctx.items,
                  onEdit: _ctx.editRecord,
                  onDestroy: _ctx.deleteRecord,
                  onCreate: _ctx.createRecord,
                  onFilter: _ctx.filterRecord,
                  showDownloadButton: _ctx.actionChecker('admin_invoice_entry', 'download'),
                  onDownload: _ctx.downloadRecord
                }, null, 8, ["loading", "columns", "data", "pagination", "onEdit", "onDestroy", "onCreate", "onFilter", "showDownloadButton", "onDownload"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "Archives"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  loading: _ctx.archive_loading == 'loading',
                  columns: _ctx.fields,
                  data: _ctx.archive_items.data,
                  pagination: _ctx.archive_items,
                  showCreateButton: false,
                  showDeleteButton: false,
                  onEdit: _ctx.editRecord,
                  onFilter: _ctx.filterRecordArchives
                }, null, 8, ["loading", "columns", "data", "pagination", "onEdit", "onFilter"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_loader, {
      title: _ctx.loader_title,
      content: _ctx.loader_content,
      visible: _ctx.visible_update_modal,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible_update_modal = false))
    }, null, 8, ["title", "content", "visible"]),
    _createVNode(_component_DownloadForm, {
      title: "Download Vendor Invoices",
      ref: "download_form_modal",
      visible: _ctx.visible_download_modal,
      onSave: _ctx.downloadVendorInvoice,
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible_download_modal = false)),
      form_action: _ctx.form_action,
      data: _ctx.download_form,
      loading: _ctx.download_submit_modal
    }, null, 8, ["visible", "onSave", "form_action", "data", "loading"])
  ]))
}